import { GtpTokenStatusEvent, postMessageRN, WebToRNAction } from '@eika-infrastruktur/mobilbank-lib';

export const dispatchGetGoogleWalletInfo = () => {
    postMessageRN({
        action: WebToRNAction.GTP_WALLET_INFO,
        payload: undefined,
    });
};

export type GpayCardStatus = 'INIT' | 'REGISTERED' | 'UNREGISTERED';

export const TOKEN_PROVIDER_VISA = 4;

export const checkNativeGooglePayTokenStatus = (tokenUniqueReference: string) => {
    postMessageRN({
        action: WebToRNAction.GTP_TOKEN_STATUS,
        payload: {
            tokenReferenceId: tokenUniqueReference,
            tokenServiceProviderCode: TOKEN_PROVIDER_VISA,
        } as GtpTokenStatusEvent,
    });
};
